import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ReportRepository, { GetUserReportResponse } from "../../repositories/ReportRepository";
import { UserType } from "../../entities/UserEntity";

interface _Props {
    reportRepository: ReportRepository;
}

@injectable()
export default class GetUserReportUseCase {
    private reportRepository: ReportRepository;

    constructor(props: _Props) {
        this.reportRepository = props.reportRepository;
    }

    public call = async (_: {
        userId: String,
        role: UserType,
        startDate: Date,
        endDate: Date,
    }): Promise<Either<ErrorEntity, GetUserReportResponse>> => {
        return this.reportRepository.getUserReport(_);
    }
}

export const GetUserReportUseCaseName = "GetUserReportUseCase";